import { FirestoreInventoryItemProps } from "types/auth";

/**
 * Resolves the saved user-facing reference for a parent inventory item.
 * Legacy records without displayReferenceMode retain their system-ID display.
 */
export function getInventoryDisplayReference(
  inventory: Pick<
    FirestoreInventoryItemProps,
    "uniqueInventoryId" | "manualDisplayReference" | "displayReferenceMode"
  >,
): string {
  const manualReference = inventory.manualDisplayReference?.trim();
  if (inventory.displayReferenceMode === "manual" && manualReference) {
    return manualReference;
  }

  return inventory.uniqueInventoryId.toString();
}
